export default __webpack_public_path__ + "static/media/Bg1.d94e7e9b.jpg";